module.exports = __webpack_public_path__ + "img/12.2db9ae17.jpg";